import { getErrorMessage } from '../utils/errors';

import { getBrowserSessionId } from './analytics/getBrowserSessionId';
import { getTabId } from './analytics/getTabId';
import { postRequest } from './api';

export const logToNewRelic = (
  title: string,
  message: string | Record<string, any>,
  method: 'fatal' | 'info' | 'debug' | 'error' | 'warn' = 'info',
  context?: Record<string, any>,
) => {
  try {
    const browserSessionId = getBrowserSessionId();
    const tabId = getTabId();
    void postRequest('/v2/debug/log', {
      title: `Players-Client: ${title}`,
      message:
        typeof message === 'string'
          ? message + ` [Browser Session ID: ${browserSessionId}] [Tab ID: ${tabId}]`
          : {
              ...message,
              browserSessionId,
              tabId,
            },
      method,
      context,
    });
  } catch (e) {
    const errorMessage = getErrorMessage(e);
    console.error(`Error sending log: ${errorMessage}`);
  }
};
